import {reqWithToken} from './requestHelper';

export async function getRooms(){
    return (await reqWithToken('api/pebooking/classrooms')).data;
}

export async function getNcutRooms(){
    return (await reqWithToken('api/classrooms/ofPE')).data;
}
